/**
 * @generated SignedSource<<6006623db49fb9e506b8a16334a16174>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlannedItemIdInput = {
  id: string;
};
export type AnalysisForecastPlannedItemsViewEnableMutation$variables = {
  input: PlannedItemIdInput;
};
export type AnalysisForecastPlannedItemsViewEnableMutation$data = {
  readonly enablePlannedItem: {
    readonly enabled: boolean;
    readonly id: string;
  };
};
export type AnalysisForecastPlannedItemsViewEnableMutation = {
  response: AnalysisForecastPlannedItemsViewEnableMutation$data;
  variables: AnalysisForecastPlannedItemsViewEnableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PlannedItem",
    "kind": "LinkedField",
    "name": "enablePlannedItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastPlannedItemsViewEnableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisForecastPlannedItemsViewEnableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a2c7f72e11b3a9903b4cb25f401e7ab",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastPlannedItemsViewEnableMutation",
    "operationKind": "mutation",
    "text": "mutation AnalysisForecastPlannedItemsViewEnableMutation(\n  $input: PlannedItemIdInput!\n) {\n  enablePlannedItem(input: $input) {\n    id\n    enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "16a909ba776bb8d3be38481a02eac8e5";

export default node;
